<template>
    <li class="struct" :id="'struct_' + node.facility_id">
        <div :class="[
            depth > 0 ? 'item-struct-child pl-1' : 'item-struct',
            rowClass(node),
        ]" :title="node.node_name_desc" @click.self="$emit('onClickItem', { node, event: $event })"
            :style="{ paddingLeft: depth > 0 ? (depth * 16 + 8) + 'px' : '' }">
            <i v-if="node.children && node.children.length" :class="[
                'pi',
                'caret',
                'ml-1',
                node.expanded ? 'pi-angle-up' : 'pi-angle-down',
            ]" @click="$emit('onClickExpand', node)">
            </i>
            <img @click="$emit('onClickItem', { node, event: $event })" :title="node.node_name" :class="[
                (!node.children || !node.children.length) ? 'ml-1' : '',
                'facility-img'
            ]" :src="require(`/public/images/24x24/${node.image_index}.png`)" width="20" />
            <div class="unselectable ml-1 facility-name" :data-testid="'struct_' + node.facility_id" disabled
                @click="$emit('onClickItem', { node, event: $event })">
                {{ node.node_name }}
            </div>
        </div>
        <ul v-if="node.children && node.children.length && node.expanded" :class="{ nested: !node.expanded }">
            <StructureNode v-for="(child, childIndex) in node.children" :key="getNodeKey(child, childIndex)"
                :node="child" :depth="depth + 1" @onClickItem="$emit('onClickItem', $event)"
                @onClickExpand="onClickExpand(child)" />
        </ul>
    </li>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import { useStructure } from './useStructure.js';
import StructureNode from './StructureNode.vue';

const props = defineProps({
    node: {
        type: Object,
        required: true,
    },
    depth: {
        type: Number,
        default: 0,
    },
});

const emit = defineEmits(['onClickItem', 'onClickExpand']);

const { getNodeKey, rowClass } = useStructure();

const onClickExpand = (child) => {
    emit('onClickExpand', child);
};
</script>

<style scoped lang="scss" src="./StyleStructure.scss"></style>